import React, {Fragment,useState,useRef} from 'react';
import { useEffect } from 'react';

import { Button } from 'reactstrap';

import Parametri from '../../parametri';
import TrasformaDateAUmano from '../TrasformaDateAUmano.js';
import FormattaImportoVideo from '../FormattaImportoVideo.js';
import Clessidra from '../Clessidra.js';

import { Page, Text, View, Document, Image, PDFViewer, pdf } from '@react-pdf/renderer';
import styles from '../stiliPdf.js';

import { haPersonalizzazione } from '../../funzioni.js';

/* Note: 

1) per chiamare il componente, devi fornire una key univoca per record in modo tale che venga rifatto il
rendering se cambi record.
Esempio:
    <VisualizzaRicevuta {...props} 
        key={statoPagina + "-" + idRecordPrimaNota}
        idRecordPrimaNota={idRecordPrimaNota} 
        flagDownload={statoPagina===STATO_SCARICA_RICEVUTA}
        jsonRicevuta={jsonRicevuta}
        callback={callbackVisualizzaRicevuta}        
    />

2) l'indicazione "(parziale)" a fianco a un pagamento dipende dal campo PARZIALE nel json_pagamenti, che viene
definito in SchedaIncassiAbbAssUnificata.js nella variabile jsonFinale e mandata al backend in modo da memorizzarla
nel json pagamenti in Prima Nota.
*/

function VisualizzaRicevuta(props) {

    const STATO_INDEFINITO = 0;
    const STATO_RICERCA_DATI = 1;
    const STATO_VISUALIZZA_PDF = 2;
    const STATO_DOWNLOAD_PDF = 3;

    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [larghezzaPdf,setLarghezzaPdf] = useState(0);
    const [fileLogo,setFileLogo]=useState('');
    const [typeLogo,setTypeLogo]=useState('');
    const [fileFirma,setFileFirma]=useState('');
    const [typeFirma,setTypeFirma]=useState('');
    const [nomeSocieta,setNomeSocieta]=useState('');
    const [capSocieta,setCapSocieta]=useState('');
    const [cittaSocieta,setCittaSocieta]=useState('');
    const [indirizzoSocieta,setIndirizzoSocieta]=useState('');
    const [pIvaSocieta,setPIvaSocieta]=useState('');
    const [codiceFiscaleSocieta,setCodiceFiscaleSocieta]=useState('');
    const [emailSocieta,setEmailSocieta]=useState('');
    const [pecSocieta,setPecSocieta]=useState('');
    const [jsonRicevuta,setJsonRicevuta]=useState('');

    const flagEmailInviata = useRef(false);

    var elem = document.getElementById("cont");

    useEffect(() => {
          if(elem) setLarghezzaPdf(elem.getBoundingClientRect().width); 
    },[elem]);

    useEffect(() => {
        if (statoPagina==STATO_DOWNLOAD_PDF) {
            downloadRicevutaPDF(jsonRicevuta);
        }

        if (
            props.flagInviaEmail &&
            !flagEmailInviata.current &&
            jsonRicevuta !== "" &&
            statoPagina !== STATO_RICERCA_DATI &&
            statoPagina !== STATO_INDEFINITO &&
            haPersonalizzazione(props.identitaSelezionata, "invia_ricevuta_email")
        ) {
            flagEmailInviata.current = true;
            inviaRicevutaPDF(jsonRicevuta);
        }
    }, [statoPagina, jsonRicevuta]);

    async function inviaRicevutaPDF(jsonRicevuta) {

        var email = "";
        if (jsonRicevuta.iscritto && jsonRicevuta.iscritto.EMAIL) {
            email = jsonRicevuta.iscritto.EMAIL;
        }
        if (jsonRicevuta.riferimento && jsonRicevuta.riferimento.EMAIL) {
            email = jsonRicevuta.riferimento.EMAIL;
        }
        if (email === "") {
            // se non è definito l'indirizzo email, non mando ricevuta via mail
            return;
        }

        const blob = await pdf(
            <DocumentoPDF jsonRicevuta={jsonRicevuta} />
        ).toBlob();

        if (blob.size <= 0) {
            window.alert("PDF non generato");
            return;
        }

        const file = new File([blob], "ricevuta.pdf", { type: "application/pdf" });

        console.log("blob", blob);
        console.log("blob.size", blob.size);
        console.log("blob.type", blob.type);

        const formData = new FormData();

        formData.append("op", "inviaRicevutaPdf");
        formData.append("emak", props.emak);
        formData.append("sessionId", props.sessionId);
        formData.append("email", email);
        formData.append("pdf", file);

        fetch(Parametri("serverURL", props.identitaSelezionata), {
            method: "POST",
            body: formData
        })
        .then(risposta => risposta.json())
        .then((valore_di_ritorno) => {
            if (valore_di_ritorno.risultatoOperazione !== 1) {
                window.alert("Errore invio ricevuta");
            }
        })
        .catch(() => {
            window.alert("Errore connessione durante l'invio della ricevuta");
        });
    }

    function scaricaLogo() {
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:"ricercaLogo", emak: props.emak,sessionId: props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
          (valoreDiRitorno) => {          
              if(valoreDiRitorno.risultatoOperazione===1){
                  if (valoreDiRitorno.risultatoRitorno[0].FILE !== undefined) {
                    setFileLogo(valoreDiRitorno.risultatoRitorno[0].FILE);
                    setTypeLogo(valoreDiRitorno.risultatoRitorno[0].TYPE);
                    setNomeSocieta(valoreDiRitorno.risultatoRitorno[0].NOME);
                    setCapSocieta(valoreDiRitorno.risultatoRitorno[0].CAP);
                    setCittaSocieta(valoreDiRitorno.risultatoRitorno[0].CITTA);
                    setIndirizzoSocieta(valoreDiRitorno.risultatoRitorno[0].INDIRIZZO);
                    setPIvaSocieta(valoreDiRitorno.risultatoRitorno[0].PIVA);
                    setCodiceFiscaleSocieta(valoreDiRitorno.risultatoRitorno[0].CODICE_FISCALE);
                    setEmailSocieta(valoreDiRitorno.risultatoRitorno[0].EMAIL);
                    setPecSocieta(valoreDiRitorno.risultatoRitorno[0].PEC);
                  }

                  if (props.jsonRicevuta) {
                    setJsonRicevuta(props.jsonRicevuta);
                    setStatoPagina(STATO_VISUALIZZA_PDF);
                  } else {
                    scaricaRicevuta(props.idRecordPrimaNota);
                  }
              }
          },
          (error) => {console.log("Errore connessione");}
        );        
    }    

    useEffect(() => {
        setStatoPagina(STATO_RICERCA_DATI);
        scaricaLogo();        
    }, [])

    const DocumentoPDF = ({ jsonRicevuta }) => {
        var stringaIscrittoResidente1="";        
        var stringaIscrittoResidente2="";
        var stringaIscrittoNascita="";
        var stringaRiferimentoResidente1="";
        var stringaRiferimentoResidente2="";    
        var stringaRiferimentoNascita="";

        console.log(jsonRicevuta)
        if (jsonRicevuta=="" || jsonRicevuta==[]) {
            return (
            <Document>
                <Page size="A4" orientation="portrait" style={styles.page}>
                    <View style={{width:"100%"}} >
                        <Text>Ricevuta non trovata</Text>
                    </View>
                </Page>
            </Document>
            )
        }

        const indirizzo = (jsonRicevuta?.iscritto?.INDIRIZZO ?? "").toString().trim();
        if (indirizzo) {
            stringaIscrittoResidente1 = "Residente in "+indirizzo;

            if (jsonRicevuta.iscritto.CAP != "" || jsonRicevuta.iscritto.CITTA || jsonRicevuta.iscritto.PROVINCIA) {
                if (jsonRicevuta.iscritto.CAP != "") stringaIscrittoResidente2 += jsonRicevuta.iscritto.CAP;
                if (jsonRicevuta.iscritto.CITTA != "") {
                    if (stringaIscrittoResidente2 != "") stringaIscrittoResidente2 += ", ";
                    stringaIscrittoResidente2 += jsonRicevuta.iscritto.CITTA;
                }
                if (jsonRicevuta.iscritto.PROVINCIA != "") {
                    if (stringaIscrittoResidente2 != "") stringaIscrittoResidente2 += " (" + jsonRicevuta.iscritto.PROVINCIA + ")";
                    else stringaIscrittoResidente2 += "Provincia " + jsonRicevuta.iscritto.PROVINCIA;
                }
            }

            if (jsonRicevuta.iscritto.LUOGO_NASCITA != "" && jsonRicevuta.iscritto.DATA_NASCITA) {
                stringaIscrittoNascita = "Nato/a a " + jsonRicevuta.iscritto.LUOGO_NASCITA + " il " + TrasformaDateAUmano({"data":jsonRicevuta.iscritto.DATA_NASCITA});
            }
        }

        // il riferimento può non esserci nel json
        if (jsonRicevuta.riferimento) {            
            if (jsonRicevuta.riferimento.INDIRIZZO != "") stringaRiferimentoResidente1 = "Residente in " + jsonRicevuta.riferimento.INDIRIZZO;
            
            if (jsonRicevuta.riferimento.CAP != "" || jsonRicevuta.riferimento.CITTA || jsonRicevuta.riferimento.PROVINCIA) {
                if (jsonRicevuta.riferimento.CAP != "") stringaRiferimentoResidente2 += jsonRicevuta.riferimento.CAP;
                if (jsonRicevuta.riferimento.CITTA != "") {
                    if (stringaRiferimentoResidente2 != "") stringaRiferimentoResidente2 += ", ";
                    stringaRiferimentoResidente2 += jsonRicevuta.riferimento.CITTA;
                }
                if (jsonRicevuta.riferimento.PROVINCIA != "") {
                    if (stringaRiferimentoResidente2 != "") stringaRiferimentoResidente2 += " (" + jsonRicevuta.riferimento.PROVINCIA + ")";
                    else stringaRiferimentoResidente2 += "Provincia " + jsonRicevuta.riferimento.PROVINCIA;
                }
            }
            
            if (jsonRicevuta.riferimento.LUOGO_NASCITA != "" && jsonRicevuta.riferimento.DATA_NASCITA) {
                stringaRiferimentoNascita = "Nato/a a " + jsonRicevuta.riferimento.LUOGO_NASCITA + " il " + TrasformaDateAUmano({"data":jsonRicevuta.riferimento.DATA_NASCITA});
            }    
        }

        return (
          <Document>
            <Page size="A4" orientation="portrait" style={styles.page}>
                <View style={{width:"100%"}} >
                    <View style={styles.tableIntestazione}>{/*apre table intestazione*/}
                        <View wrap={false} style={styles.tableRowIntestazione}> 
                            <View style={styles.tableColIntestazioneSx}> 
                                <View style={styles.tableCell}> 
                                    {fileLogo !== "" ? <Image style={styles.logo} src={"data:" + typeLogo + ";base64," + fileLogo} />:<Text></Text>}
                                </View> 
                            </View> 
                            <View style={styles.tableColIntestazioneDx}>   
                                <View style={styles.tableCellIntestazione}> 
                                    {nomeSocieta !== "" ?<Text style={styles.nomesocieta}>{nomeSocieta}</Text>:<Text></Text>}
                                    
                                    {indirizzoSocieta !== "" ?
                                        <Text style={styles.datisocieta}>{indirizzoSocieta}
                                        {cittaSocieta !== "" ?
                                            capSocieta !== "" ?
                                                " "+capSocieta+" "+cittaSocieta
                                            :" "+cittaSocieta
                                        :""}
                                        </Text>
                                    :<Text></Text>}
                                    {pIvaSocieta !== "" && <Text style={styles.datisocieta}>Partita IVA: {pIvaSocieta}</Text>}
                                    {codiceFiscaleSocieta !== "" && <Text style={styles.datisocieta}>Codice Fiscale: {codiceFiscaleSocieta}</Text>}
                                    {emailSocieta !== "" && <Text style={styles.datisocieta}>Email: {emailSocieta}</Text>}
                                    {pecSocieta !== "" && <Text style={styles.datisocieta}>PEC: {pecSocieta}</Text>}
                                    
                                    <Text style={styles.titolo}>
                                        {jsonRicevuta.titolo}{jsonRicevuta.numero!="" && jsonRicevuta.numero!=undefined && " n. "+jsonRicevuta.numero}
                                        {props.persona ? <View style={{width:"100%"}} ><Text> da {props.persona}</Text></View> : ""}
                                    </Text>
                                </View> 
                            </View> 
                        </View> 
                    </View>{/*chiude table intestazione*/}

                    <View style={styles.tableNoBordo}>{/*apre table dati*/}
                        <View style={styles.rigaRicevuta}> 
                            <Text style={styles.testoGrande}>{jsonRicevuta.ricevente}</Text>
                        </View>  

                        {jsonRicevuta.riferimento &&
                            <>
                                <View style={styles.rigaRicevutaCentrata}> 
                                    <Text style={styles.testoGrassetto}>{jsonRicevuta.riferimento.COGNOME} {jsonRicevuta.riferimento.NOME}</Text>
                                    {jsonRicevuta.riferimento.CODICE_FISCALE != "" && <Text style={styles.testoNormale10}>Codice fiscale {jsonRicevuta.riferimento.CODICE_FISCALE}</Text>}
                                    {stringaRiferimentoResidente1 != "" && <Text style={styles.testoNormale10}>{stringaRiferimentoResidente1}</Text>}
                                    {stringaRiferimentoResidente2 != "" && <Text style={styles.testoNormale10}>{stringaRiferimentoResidente2}</Text>}
                                    {stringaRiferimentoNascita != "" && <Text style={styles.testoNormale10}>{stringaRiferimentoNascita}</Text>}
                                </View> 
                                <View style={styles.rigaRicevuta}>
                                    <Text style={styles.testoGrande}>per l'iscritto</Text>
                                </View>
                            </>
                        }

                        <View style={styles.rigaRicevutaCentrata}> 
                            <Text style={styles.testoGrassetto}>{jsonRicevuta.iscritto.COGNOME} {jsonRicevuta.iscritto.NOME}</Text>
                            {jsonRicevuta.iscritto.CODICE_FISCALE != "" && <Text style={styles.testoNormale10}>Codice fiscale {jsonRicevuta.iscritto.CODICE_FISCALE}</Text>}
                            {stringaIscrittoResidente1 != "" && <Text style={styles.testoNormale10}>{stringaIscrittoResidente1}</Text>}
                            {stringaIscrittoResidente2 != "" && <Text style={styles.testoNormale10}>{stringaIscrittoResidente2}</Text>}
                            {stringaIscrittoNascita != "" && <Text style={styles.testoNormale10}>{stringaIscrittoNascita}</Text>}                                           
                            {jsonRicevuta.iscritto.NUMERO_TESSERA != "" && <Text style={styles.testoNormale10}>Tessera n. {jsonRicevuta.iscritto.NUMERO_TESSERA}</Text>}                                        
                        </View>

                        <View style={styles.rigaRicevuta}> 
                            <Text style={styles.testoGrande}>la somma pari a</Text>
                        </View> 

                        <View style={styles.rigaRicevutaCentrata}> 
                            <Text style={styles.testoGrassetto}>{FormattaImportoVideo(jsonRicevuta.importo)} euro</Text>
                        </View>                                     

                        {jsonRicevuta.modalitaPagamento && jsonRicevuta.modalitaPagamento != "" && 
                            <View style={styles.rigaRicevuta}> 
                                <Text style={styles.testoGrassetto}>Modalità di pagamento: {jsonRicevuta.modalitaPagamento}</Text>                                
                            </View>                                     
                        }

                        {jsonRicevuta.pagamenti && jsonRicevuta.pagamenti.length > 0 
                        ?
                            <View style={{ marginTop: 20 }}>
                                <Text style={styles.testoGrassetto}>Dettaglio Pagamenti:</Text>
                                
                                {/* Intestazione tabella */}
                                <View style={{ flexDirection: "row", borderBottom: 1, borderTop: 1, paddingVertical: 4, marginTop: 8 }}>
                                <View style={{ flex: 4 }}>
                                    <Text style={styles.testoGrassetto}>Descrizione</Text>
                                </View>
                                <View style={{ flex: 1, alignItems: "flex-end" }}>
                                    <Text style={styles.testoGrassetto}>Importo</Text>
                                </View>
                                </View>

                                {/* Righe della tabella (solo se importo != 0) */}
                                {jsonRicevuta.pagamenti
                                .filter(p => parseFloat(p.IMPORTO) != 0)
                                .map((p, index) => (
                                    <View key={index} style={{ flexDirection: "row", paddingVertical: 2, borderBottom: 0.5 }}>
                                    <View style={{ flex: 4 }}>
                                        <Text style={styles.testoNormale10}>
                                            {p.DESCRIZIONE}
                                            {p.PARZIALE==1 && " (parziale)"}
                                        </Text>
                                    </View>
                                    <View style={{ flex: 1, alignItems: "flex-end" }}>
                                        <Text style={styles.testoNormale10}>{FormattaImportoVideo(p.IMPORTO)} €</Text>
                                    </View>
                                    </View>
                                ))}

                                {/* Riga di totale */}
                                <View style={{ flexDirection: "row", paddingBottom: 2, borderBottom: 1, marginTop: 4 }}>
                                    <View style={{ flex: 4 }}>
                                        <Text style={styles.testoGrassetto}>Totale</Text>
                                    </View>
                                    <View style={{ flex: 1, alignItems: "flex-end" }}>
                                        <Text style={styles.testoGrassetto}>
                                        {
                                            FormattaImportoVideo(
                                            jsonRicevuta.pagamenti
                                                .filter(p => parseFloat(p.IMPORTO) != 0)
                                                .reduce((tot, p) => tot + parseFloat(p.IMPORTO), 0)
                                            )
                                        } €
                                        </Text>
                                    </View>
                                </View>

                            </View>
                    
                        :
                            <View style={styles.rigaRicevutaCentrata}> 
                                <Text style={styles.testoGrassetto}>{jsonRicevuta.descrizione}</Text>
                            </View>
                        }

                        {jsonRicevuta.note && jsonRicevuta.note != "" && 
                            <View style={styles.rigaRicevuta}> 
                                <Text style={styles.testoGrande}>Note: {jsonRicevuta.note}</Text>
                            </View>                                     
                        }

                        <View style={styles.rigaRicevutaCentrata}> 
                            <Text style={styles.testoNormale10}>{jsonRicevuta.finale}</Text>
                        </View>                                                               

                    </View>

                    <View style={styles.tabellaDataFirma}>
                        <View style={styles.tabellaDataFirmaRow}>
                            <View style={styles.tabellaDataFirmaCol}>
                                <Text style={styles.tabellaDataFirmaCellHeader}>DATA</Text>
                                <Text style={styles.tabellaDataFirmaCellData}><TrasformaDateAUmano data={jsonRicevuta.data}/></Text>
                            </View>
                            <View style={styles.tabellaDataFirmaCol}>
                                <Text style={styles.tabellaDataFirmaCellHeader}>FIRMA</Text>
                                {jsonRicevuta.firmaGraficaFile && jsonRicevuta.firmaGraficaFile !== "" ?
                                    <View style={styles.tableCell}> 
                                        <Image style={styles.immagineFirmaGrafica} src={jsonRicevuta.firmaGraficaFile} />
                                    </View>
                                :
                                    <View style={styles.rigaPerFirma}/>             
                                }
                            </View>
                        </View>
                    </View>        

                </View>
            </Page>
          </Document>
        )
    };

    async function downloadRicevutaPDF(jsonRicevuta) {
        const blob = await pdf(<DocumentoPDF jsonRicevuta={jsonRicevuta} />).toBlob(); // Convert the document to a Blob
        const url = URL.createObjectURL(blob); // Create a temporary URL
        const link = document.createElement("a"); // Create a link element
        link.href = url; // Assign the Blob URL
        link.download = "Ricevuta"; // Set the download filename
        document.body.appendChild(link); // Append the link to the document
        link.click(); // Simulate a click to trigger the download
        document.body.removeChild(link); // Clean up
        URL.revokeObjectURL(url); // Release the memory        
    }

    function scaricaRicevuta(id) {
        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ op: "scaricaRicevuta", id:id, emak: props.emak, sessionId: props.sessionId })
        };
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valore_di_ritorno) => {
                    if (valore_di_ritorno.verifvers === 0) {
                        // necessario aggiornare la app
                        props.callbackAggiornaApp();
                        return;
                    }
                    if (valore_di_ritorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }
                    if (valore_di_ritorno.risultatoOperazione !== 1) { 
                        window.alert("Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); 
                        props.callback(props.PAGINECLIENTI.login);
                        return; 
                    }
                    
                    setJsonRicevuta(valore_di_ritorno.jsonRicevuta);

                    if (props.flagDownload) {     
                        setStatoPagina(STATO_DOWNLOAD_PDF);
                    } else {
                        setStatoPagina(STATO_VISUALIZZA_PDF);
                    }
                },
                (error) => {
                    props.callback(props.PAGINECLIENTI.login);
                    return;
                }
            );                                 
    }

    if (statoPagina==STATO_RICERCA_DATI) {
        const h = props.dimensioniApp?props.dimensioniApp.yMain:"";
        return (<div style={{height: h,width: "100%",display:"flex"}}><Clessidra loading={true}/></div>)
    }

    if (statoPagina==STATO_VISUALIZZA_PDF) {
        const h = props.dimensioniApp?props.dimensioniApp.yMain:"";
        return (
            <div style={{display:"flex", flexDirection:"column", height: h}}>
                <PDFViewer style={{width: "100%", flex:1}}>
                    <DocumentoPDF jsonRicevuta={jsonRicevuta} />
                </PDFViewer>
                <Button color="primary" style={{margin:2 }} onClick={() => props.callback()}>Chiudi</Button>
            </div>
        );
    }

    if (statoPagina==STATO_DOWNLOAD_PDF) {
        return (<></>);
    }

    return(
        <div>Errore VisualizzaRicevuta: pagina non trovata</div>
    )
}

export default VisualizzaRicevuta;